import React, { Component } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import Blank from '../../hoc/Blank/Blank';
import DriverData from '../../components/DriverData/DriverData';
import AddDriverButtons from '../../components/DriverButtons/AddDriverButtons';
import Modal from '../../components/UI/Modal/Modal';
import AddDriverErrorModal from '../../components/ErrorModals/AddDriverErrorModal/AddDriverErrorModal';
import * as actions from '../../store/actions/index';

class AddDriver extends Component {
    state = {
        driverId: 0,
        addDriver: null,
        driverValid: true,
        cancel: false,
        reload: false,
        closeModal: false
    }

    componentDidMount () {        
        this.props.onInitDriver();
        
    }

    componentDidUpdate(prevProps) {
        if (this.props.added) {
            this.props.onInitDriver();
            this.props.history.push('/drivers?added');
        }       
    }

    validatePage ()  {
      
        let valid = true;
        valid = valid && this.validateIdentifier('firstName');
        valid = this.validateIdentifier('lastName') && valid;
        valid = this.validateIdentifier('phone') && valid;
        valid = this.validateIdentifier('numberOfBags') && valid;
        
        return valid;
    }


    validateIdentifier (identifier) 
    {
        if (this.props.driver[identifier + '_valid'] == false)
        {
            this.props.onUpdateDriver(identifier + '_touched',true);
            return false;
        }
        return true;
    }


    DataChanged = (id,value) => {
        this.props.onUpdateDriver(id,value);
    }

    checkPhone = (value) => {
        this.props.onCheckPhone(value);
    }

    modalCancelHandler = () => {
        this.setState({driverValid: true});
    }

    cancelPageHandler = () => {
        this.props.onInitDriver();

        this.props.history.push('/drivers');
        
    }

    addDriver = () => {
        if (!this.validatePage())
        {
            this.setState({driverValid:false});
        }
        else
        {
            this.setState({driverValid:true});
                        
            this.props.onAddDriver();
        }
    }    

    render () {
        
        let modal = null;
        
        if (!this.state.driverValid)
        {
            modal = <AddDriverErrorModal modalClosed={this.modalCancelHandler}/>;
        }

        return (
            <Blank>
                <Modal show={modal != null && !this.state.driverValid} modalClosed={this.cancelPageHandler}>
                    {modal}
                </Modal>
                <DriverData  
                    onDataChanged={this.DataChanged} onCheckPhone={this.checkPhone}/>
                <AddDriverButtons  onAddDriver={this.addDriver} onCancelled={this.cancelPageHandler}/>
            </Blank>
        );
    }
}


const mapStateToProps = state => {
    return {
      driver: state.orders.driver,        
      isAuthenticated: state.orders.token !== null,
      added: state.orders.added
    };
}

const mapDispatchToProps = dispatch => {
    return {
        onInitDriver: () => dispatch(actions.initDriver()),
        onAddDriver:() => dispatch(actions.addDriver()),
        onUpdateDriver: (id,value) => dispatch(actions.updateDriverData(id,value)),
        onCheckPhone: (value) => dispatch(actions.checkDriverPhone(value))
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(AddDriver);


// WEBPACK FOOTER //
// ./src/containers/AddDriver/AddDriver.js